export const listUiBuilderPages = `
    query MyQuery($hotelId: String!, $lang: String) {
      listUiBuilderPages(hotelId: $hotelId, lang: $lang) {
        hotelId
        id
        name
        status
        uiConfiguration
        uiConfigurationPublished
        createdAt
        createdBy
        updatedAt
        updatedBy
        publishedAt
      }
    }
  `;

export const listFlowOptions = `
  query MyQuery ($lang: String){
    listFlowOptions(lang: $lang) {
      id
      label
    }
  }
`;

export const queryListHotelModuleOptions = `
query MyQuery ($lang: String) {
  listHotelModuleOptions(lang: $lang) {
    id
    label
  }
}
`;

export const listUiBuilderMenuItems = `
query MyQuery($hotelId: String!, $lang: String) {
  listUiBuilderMenuItems(hotelId: $hotelId, lang: $lang) {
    createdAt
    createdBy
    hotelId
    menuList {
      id
      name
      pageId
    }
    updatedAt
    updatedBy
    version
  }
}
`;

export const listUiBuilderHamburgerMenuItems = `
query MyQuery($hotelId: String!, $lang: String) {
  getUiBuilderHamburgerMenuDetails(input : {hotelId: $hotelId,lang: $lang}) {
    post {
      category
      createdAt
      createdBy
      flow
      externalLink
      hotelId
      id
      isActive
      menuIconUrl
      lang
      name
      pages
      pk
      redirectOptions
      sk
      updatedAt
      updatedBy
      version
    }
    pre {
      category
      createdAt
      createdBy
      flow
      externalLink
      hotelId
      id
      isActive
      menuIconUrl
      lang
      name
      pages
      pk
      redirectOptions
      sk
      updatedAt
      updatedBy
      version
    }
  }
}
`;
